import { useEffect, useState } from 'react';
import {
  getEnterpriseWorkspaceRole,
  setEnterpriseWorkspaceRole,
  type EnterpriseWorkspaceRole,
} from '../lib/enterprise-workspace-preferences';

export function useEnterpriseWorkspaceRole() {
  const [role, setRole] = useState<EnterpriseWorkspaceRole>(() => getEnterpriseWorkspaceRole());

  useEffect(() => {
    setEnterpriseWorkspaceRole(role);
  }, [role]);

  return { role, setRole };
}

